import React from 'react';

const SystemSettings = () => {
  return (
    <div className="system-settings">
      <div className="page-header">
        <h2>Sistem Ayarları</h2>
        <p>Sistem konfigürasyonunu yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default SystemSettings; 